import { FileIdsValue, SelectMultipleValue } from '@kaizenplatform/hugot-entity';
import { createElement, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { DynamicSchemaDefinitionSingleLineText } from '../../../../../generated/graphql';
import AnchorTypography from '../../../primitive/AnchorTypography';
import { AfterValueText, BeforeValueText } from '../../../primitive/DiffText';
import Linkify from '../../../primitive/Linkify';
import { Label, LabelAndValue, Value, ValueText } from '../../ProjectBasicSettingDetail';

interface Props {
  field: Pick<DynamicSchemaDefinitionSingleLineText, 'key'>;
  value: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>;
  beforeValue?: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>;
}

const AsSingleLineText = ({ field, value, beforeValue }: Props) => {
  const sharedUrl = value.get(field.key) as string;
  const beforeSharedUrl = beforeValue != null ? (beforeValue.get(field.key) as string) : '';

  return (
    <LabelAndValue>
      <Label>
        <FormattedMessage id="project_basic_setting_detail.assets.label.url" />
      </Label>
      <Value>
        {beforeValue == null || sharedUrl === beforeSharedUrl ? (
          <ValueText>
            {sharedUrl !== '' ? (
              <Linkify text={sharedUrl}>
                {(url, key) => (
                  <AnchorTypography key={key} href={url} withNewTab>
                    {url}
                  </AnchorTypography>
                )}
              </Linkify>
            ) : (
              <FormattedMessage id="creative_brief_detail.field.empty" />
            )}
          </ValueText>
        ) : (
          <>
            <BeforeValueText>
              {beforeSharedUrl !== '' ? (
                <Linkify text={beforeSharedUrl}>
                  {(url, key) => (
                    <AnchorTypography key={key} href={url} withNewTab>
                      {url}
                    </AnchorTypography>
                  )}
                </Linkify>
              ) : (
                <FormattedMessage id="creative_brief_detail.field.empty" />
              )}
            </BeforeValueText>
            <AfterValueText>
              {sharedUrl !== '' ? (
                <Linkify text={sharedUrl}>
                  {(url, key) => (
                    <AnchorTypography key={key} href={url} withNewTab>
                      {url}
                    </AnchorTypography>
                  )}
                </Linkify>
              ) : (
                <FormattedMessage id="creative_brief_detail.field.empty" />
              )}
            </AfterValueText>
          </>
        )}
      </Value>
    </LabelAndValue>
  );
};

export default AsSingleLineText;
